import axios from 'axios';

export default {
  getXsellItemsForProduct,
  getXsellItems,
  getMembershipXsellProducts
};

export function getXsellItemsForProduct(params) {
  return axios.get('/api/xsell/getXsellItemsForProduct', { params });
}

export function getXsellItems() {
  return axios.get('/api/xsell/getXsellItems');
}

export function getMembershipXsellProducts() {
  return axios.get('/api/xsell/getMembershipXsellProducts');
}